var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGooglePlay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 65,
    fill: "none",
    viewBox: "0 0 215 65",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 214,
    height: 63,
    rx: 9.5,
    fill: "white",
    stroke: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.52 16.884c0 1.344-.398 2.416-1.194 3.2-.892.944-2.07 1.424-3.504 1.424-1.386 0-2.548-.48-3.52-1.44-.971-.96-1.449-2.16-1.449-3.568 0-1.424.478-2.608 1.45-3.568.97-.96 2.133-1.44 3.519-1.44.685 0 1.338.128 1.959.4.62.272 1.115.624 1.497 1.072l-.844.848c-.637-.752-1.497-1.136-2.612-1.136a3.6 3.6 0 0 0-2.612 1.072c-.732.704-1.099 1.632-1.099 2.768s.367 2.064 1.1 2.768c.732.704 1.608 1.072 2.61 1.072 1.068 0 1.96-.352 2.677-1.072.461-.464.732-1.12.796-1.952h-3.472V16.18h4.634c.032.24.064.48.064.704ZM82.863 12.884h-4.348v3.04h3.918v1.152h-3.918v3.04h4.348V21.3H77.29v-9.6h5.574v1.184ZM88.039 21.3h-1.227v-8.416h-2.675V11.7h6.561v1.184h-2.675V21.3h.016ZM95.46 21.3v-9.6h1.226v9.6h-1.227ZM102.133 21.3h-1.227v-8.416h-2.675V11.7h6.561v1.184h-2.675V21.3h.016ZM117.231 20.052c-.94.976-2.102 1.456-3.504 1.456-1.401 0-2.564-.48-3.504-1.456-.939-.976-1.401-2.16-1.401-3.552s.462-2.592 1.401-3.552c.94-.976 2.103-1.456 3.504-1.456 1.386 0 2.548.48 3.504 1.456.94.976 1.417 2.16 1.417 3.552-.016 1.408-.477 2.592-1.417 3.552Zm-6.1-.8c.701.72 1.577 1.072 2.596 1.072 1.019 0 1.895-.352 2.596-1.072.701-.72 1.067-1.632 1.067-2.752 0-1.12-.35-2.032-1.067-2.752-.701-.72-1.577-1.072-2.596-1.072-1.019 0-1.895.352-2.596 1.072-.7.72-1.067 1.632-1.067 2.752 0 1.12.367 2.032 1.067 2.752ZM120.368 21.3v-9.6h1.497l4.651 7.472h.047l-.047-1.856V11.7h1.226v9.6h-1.274l-4.858-7.824h-.047l.047 1.856V21.3h-1.242Z",
    fill: "#2C2C2C",
    stroke: "#2C2C2C",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.519 35.3c-3.742 0-6.8 2.864-6.8 6.8 0 3.92 3.058 6.8 6.8 6.8 3.743 0 6.801-2.88 6.801-6.8 0-3.936-3.058-6.8-6.801-6.8Zm0 10.928c-2.054 0-3.822-1.696-3.822-4.128 0-2.448 1.768-4.128 3.822-4.128 2.055 0 3.823 1.68 3.823 4.128 0 2.432-1.784 4.128-3.823 4.128ZM93.676 35.3c-3.742 0-6.8 2.864-6.8 6.8 0 3.92 3.058 6.8 6.8 6.8 3.743 0 6.801-2.88 6.801-6.8 0-3.936-3.058-6.8-6.8-6.8Zm0 10.928c-2.054 0-3.822-1.696-3.822-4.128 0-2.448 1.768-4.128 3.822-4.128 2.055 0 3.823 1.68 3.823 4.128 0 2.432-1.768 4.128-3.823 4.128Zm-17.645-8.832v2.88h6.88c-.208 1.616-.749 2.816-1.561 3.632-1.004 1.008-2.564 2.112-5.304 2.112-4.236 0-7.549-3.424-7.549-7.68s3.313-7.68 7.55-7.68c2.277 0 3.949.896 5.175 2.064l2.023-2.032c-1.72-1.648-3.998-2.912-7.215-2.912-5.797 0-10.67 4.736-10.67 10.576 0 5.824 4.873 10.576 10.67 10.576 3.138 0 5.495-1.024 7.342-2.96 1.895-1.904 2.485-4.592 2.485-6.752 0-.672-.048-1.296-.16-1.808h-9.666v-.016Zm72.16 2.24c-.558-1.52-2.278-4.336-5.797-4.336-3.488 0-6.386 2.752-6.386 6.8 0 3.808 2.866 6.8 6.72 6.8 3.106 0 4.905-1.904 5.638-3.008l-2.309-1.552c-.765 1.136-1.816 1.888-3.329 1.888-1.513 0-2.596-.704-3.28-2.064l9.061-3.76-.318-.768Zm-9.237 2.272c-.08-2.624 2.022-3.968 3.535-3.968 1.179 0 2.182.592 2.517 1.44l-6.052 2.528Zm-7.358 6.592h2.978v-20h-2.978v20Zm-4.873-11.68h-.112c-.669-.8-1.943-1.52-3.567-1.52-3.392 0-6.498 2.992-6.498 6.832 0 3.808 3.106 6.784 6.498 6.784 1.608 0 2.898-.72 3.567-1.552h.096v.976c0 2.608-1.386 4-3.615 4-1.816 0-2.947-1.312-3.409-2.416l-2.595 1.088c.748 1.808 2.723 4.016 6.004 4.016 3.487 0 6.434-2.064 6.434-7.088V35.716h-2.819v1.104h.016Zm-3.424 9.408c-2.055 0-3.775-1.728-3.775-4.096 0-2.4 1.72-4.144 3.775-4.144 2.022 0 3.615 1.76 3.615 4.144.016 2.368-1.577 4.096-3.615 4.096ZM162.142 28.5h-7.119v20h2.978v-7.584h4.157c3.297 0 6.53-2.4 6.53-6.208 0-3.808-3.265-6.208-6.546-6.208Zm.064 9.632h-4.221v-6.864h4.221c2.229 0 3.487 1.856 3.487 3.424 0 1.568-1.258 3.44-3.487 3.44Zm18.378-2.864c-2.15 0-4.379.96-5.303 3.056l2.644 1.104c.557-1.104 1.608-1.472 2.707-1.472 1.529 0 3.106.928 3.121 2.576v.208c-.541-.304-1.688-.768-3.105-.768-2.851 0-5.733 1.568-5.733 4.496 0 2.672 2.325 4.4 4.937 4.4 1.99 0 3.105-.896 3.79-1.952h.096v1.552h2.866v-7.664c.016-3.552-2.628-5.536-6.02-5.536Zm-.366 10.96c-.972 0-2.325-.496-2.325-1.696 0-1.536 1.688-2.128 3.153-2.128 1.306 0 1.927.288 2.707.672a3.599 3.599 0 0 1-3.535 3.152Zm16.85-10.528-3.409 8.672h-.095l-3.536-8.672h-3.201l5.303 12.128-3.025 6.736h3.105l8.17-18.864h-3.312Zm-26.756 12.8h2.978v-20h-2.978v20Z",
    fill: "#2C2C2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.626 12.564c-.462.496-.733 1.264-.733 2.24v35.392c0 .992.271 1.76.733 2.24l.111.112L36.47 32.74v-.48L16.737 12.452l-.111.112Z",
    fill: "url(#paint0_linear_1405_21489)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m43.048 39.348-6.577-6.608v-.48l6.577-6.608.144.08 7.788 4.448c2.23 1.264 2.23 3.344 0 4.624l-7.788 4.448-.144.096Z",
    fill: "url(#paint1_linear_1405_21489)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.19 39.252 36.47 32.5 16.625 52.436c.732.784 1.943.88 3.312.096l23.252-13.28Z",
    fill: "url(#paint2_linear_1405_21489)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m43.19 25.748-23.267-13.28c-1.37-.784-2.58-.688-3.313.096L36.47 32.5l6.72-6.752Z",
    fill: "url(#paint3_linear_1405_21489)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m43.047 39.108-23.124 13.2c-1.29.736-2.453.688-3.186.016l-.111.112.111.112c.749.672 1.896.72 3.186-.016l23.267-13.28-.143-.144Z",
    fill: "#171717"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M16.626 52.212c-.462-.496-.733-1.264-.733-2.24v.24c0 .992.271 1.76.733 2.24l.111-.112-.111-.128ZM50.978 34.58l-7.947 4.528.143.144 7.788-4.448c1.115-.64 1.672-1.472 1.672-2.304-.08.752-.637 1.504-1.656 2.08Z",
    fill: "#171717"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M19.923 12.692 50.978 30.42c1.004.576 1.577 1.312 1.673 2.08 0-.832-.558-1.68-1.673-2.304L19.923 12.468c-2.23-1.264-4.045-.208-4.045 2.352v.24c0-2.576 1.831-3.632 4.045-2.368Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1405_21489",
    x1: 34.717,
    y1: 14.435,
    x2: 7.866,
    y2: 41.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1405_21489",
    x1: 53.885,
    y1: 32.502,
    x2: 15.349,
    y2: 32.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1405_21489",
    x1: 39.538,
    y1: 36.174,
    x2: 3.125,
    y2: 72.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1405_21489",
    x1: 11.621,
    y1: 0.782,
    x2: 27.881,
    y2: 16.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGooglePlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-play.d68baf1fc7f4f46963ad8e6b1aadab60.svg";